/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface ListEventEntitiesResponse
 */
export interface ListEventEntitiesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ListEventEntitiesResponse
     */
    data: Array<ListEventEntitiesResponseDataEnum>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEventEntitiesResponse
     */
    pagination: Pagination;
}

/**
* @export
* @enum {string}
*/
export enum ListEventEntitiesResponseDataEnum {
    Absence = 'Absence',
    AbsenceCategory = 'AbsenceCategory',
    AccessRole = 'AccessRole',
    AccessRolesPermission = 'AccessRolesPermission',
    Address = 'Address',
    BatchJobLog = 'BatchJobLog',
    BatchJobMessage = 'BatchJobMessage',
    BillingCancellation = 'BillingCancellation',
    BillingCouponRedemption = 'BillingCouponRedemption',
    BillingCredit = 'BillingCredit',
    BillingCreditDelta = 'BillingCreditDelta',
    BillingDetail = 'BillingDetail',
    BillingInvoice = 'BillingInvoice',
    BillingInvoiceLine = 'BillingInvoiceLine',
    BillingPackage = 'BillingPackage',
    BillingPackageQuotaOverride = 'BillingPackageQuotaOverride',
    BillingPackagesBillingProductPrice = 'BillingPackagesBillingProductPrice',
    BillingPayment = 'BillingPayment',
    BillingPaymentMethod = 'BillingPaymentMethod',
    BillingProduct = 'BillingProduct',
    BillingProductPrice = 'BillingProductPrice',
    BillingQuotaDefinition = 'BillingQuotaDefinition',
    BillingQuotaOverride = 'BillingQuotaOverride',
    BillingSubscription = 'BillingSubscription',
    BillingSubscriptionsBillingProductPrice = 'BillingSubscriptionsBillingProductPrice',
    BillingWallet = 'BillingWallet',
    BillingWalletType = 'BillingWalletType',
    BudgetSummary = 'BudgetSummary',
    ClockInPortal = 'ClockInPortal',
    ClockInPortalsLocation = 'ClockInPortalsLocation',
    ClockingEvent = 'ClockingEvent',
    ClockingSetting = 'ClockingSetting',
    CompaniesFeatureFlag = 'CompaniesFeatureFlag',
    CompaniesFeatureGroup = 'CompaniesFeatureGroup',
    Company = 'Company',
    CompanyNotificationChannel = 'CompanyNotificationChannel',
    CompanyOnboarding = 'CompanyOnboarding',
    CompanySetting = 'CompanySetting',
    DaySummary = 'DaySummary',
    DigiticketsConnection = 'DigiticketsConnection',
    DigiticketsScheduleMap = 'DigiticketsScheduleMap',
    Document = 'Document',
    DocumentAcceptance = 'DocumentAcceptance',
    DocumentRead = 'DocumentRead',
    DocumentVersion = 'DocumentVersion',
    DocumentVersionsEmployee = 'DocumentVersionsEmployee',
    DocumentsEmployee = 'DocumentsEmployee',
    DocumentsJobRole = 'DocumentsJobRole',
    EmergencyContact = 'EmergencyContact',
    Employee = 'Employee',
    EmployeeAbsenceSummary = 'EmployeeAbsenceSummary',
    EmployeeAttribute = 'EmployeeAttribute',
    EmployeeClockingProfile = 'EmployeeClockingProfile',
    EmployeeGroup = 'EmployeeGroup',
    EmployeeInvite = 'EmployeeInvite',
    EmployeeLeaveBalancesSummary = 'EmployeeLeaveBalancesSummary',
    EmployeeLeaveSummary = 'EmployeeLeaveSummary',
    EmployeeLeaveTypeBalance = 'EmployeeLeaveTypeBalance',
    EmployeeMessage = 'EmployeeMessage',
    EmployeeMessageRecipient = 'EmployeeMessageRecipient',
    EmployeeNotificationChannel = 'EmployeeNotificationChannel',
    EmployeeOnboarding = 'EmployeeOnboarding',
    EmployeePayDetail = 'EmployeePayDetail',
    EmployeePersonalDetail = 'EmployeePersonalDetail',
    EmployeesAccessRole = 'EmployeesAccessRole',
    EmployeesAccessRolesPermission = 'EmployeesAccessRolesPermission',
    EmployeesAccessRolesPermissionsTarget = 'EmployeesAccessRolesPermissionsTarget',
    EmployeesEmployeeAttribute = 'EmployeesEmployeeAttribute',
    EmployeesJobRole = 'EmployeesJobRole',
    EmployeesLocation = 'EmployeesLocation',
    EmployeesSchedule = 'EmployeesSchedule',
    FeaturesEnabled = 'FeaturesEnabled',
    History = 'History',
    HolidayRegion = 'HolidayRegion',
    IcalFeed = 'IcalFeed',
    IcrTouchConnection = 'IcrTouchConnection',
    IcrTouchScheduleConfig = 'IcrTouchScheduleConfig',
    JobRole = 'JobRole',
    LeaveAdjustment = 'LeaveAdjustment',
    LeaveAllowanceChunk = 'LeaveAllowanceChunk',
    LeavePeriod = 'LeavePeriod',
    LeavePoliciesLeaveType = 'LeavePoliciesLeaveType',
    LeavePolicy = 'LeavePolicy',
    LeaveRequest = 'LeaveRequest',
    LeaveSetting = 'LeaveSetting',
    LeaveSettingsDefaultLeaveApprover = 'LeaveSettingsDefaultLeaveApprover',
    LeaveType = 'LeaveType',
    LeaveTypeAccrual = 'LeaveTypeAccrual',
    Location = 'Location',
    MfaDevice = 'MfaDevice',
    NotificationSetting = 'NotificationSetting',
    Offer = 'Offer',
    OffersBehaviour = 'OffersBehaviour',
    OffersQuota = 'OffersQuota',
    OffersRedemption = 'OffersRedemption',
    OffersUsage = 'OffersUsage',
    OpenShiftResponse = 'OpenShiftResponse',
    PayCycle = 'PayCycle',
    PayPeriod = 'PayPeriod',
    PayRule = 'PayRule',
    PayType = 'PayType',
    PendingAction = 'PendingAction',
    PublicHoliday = 'PublicHoliday',
    Schedule = 'Schedule',
    ScheduleEvent = 'ScheduleEvent',
    ScheduleEventsSchedule = 'ScheduleEventsSchedule',
    ScheduleOverviewSummary = 'ScheduleOverviewSummary',
    ScheduleSetting = 'ScheduleSetting',
    ScheduleTemplate = 'ScheduleTemplate',
    ScheduledBreak = 'ScheduledBreak',
    Shift = 'Shift',
    ShiftArea = 'ShiftArea',
    ShiftAreaSession = 'ShiftAreaSession',
    ShiftAreasLocation = 'ShiftAreasLocation',
    ShiftConflict = 'ShiftConflict',
    ShiftCost = 'ShiftCost',
    ShiftSwap = 'ShiftSwap',
    ShiftTemplate = 'ShiftTemplate',
    ShiftTemplateAreaSession = 'ShiftTemplateAreaSession',
    ShiftTemplateBreak = 'ShiftTemplateBreak',
    ShiftTemplatesTag = 'ShiftTemplatesTag',
    ShiftsTag = 'ShiftsTag',
    Tag = 'Tag',
    TimesheetBreak = 'TimesheetBreak',
    TimesheetEntriesTag = 'TimesheetEntriesTag',
    TimesheetEntry = 'TimesheetEntry',
    TimesheetEntryConflict = 'TimesheetEntryConflict',
    TimesheetEntryCost = 'TimesheetEntryCost',
    TimesheetEntryExport = 'TimesheetEntryExport',
    TimesheetEntrySummary = 'TimesheetEntrySummary',
    TimesheetSetting = 'TimesheetSetting',
    TrekksoftClientCredential = 'TrekksoftClientCredential',
    Unavailability = 'Unavailability',
    Upload = 'Upload',
    User = 'User',
    WorkPattern = 'WorkPattern',
    WorkPatternOverride = 'WorkPatternOverride'
}


/**
 * Check if a given object implements the ListEventEntitiesResponse interface.
 */
export function instanceOfListEventEntitiesResponse(value: object): value is ListEventEntitiesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEventEntitiesResponseFromJSON(json: any): ListEventEntitiesResponse {
    return ListEventEntitiesResponseFromJSONTyped(json, false);
}

export function ListEventEntitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEventEntitiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEventEntitiesResponseToJSON(json: any): ListEventEntitiesResponse {
      return ListEventEntitiesResponseToJSONTyped(json, false);
  }

  export function ListEventEntitiesResponseToJSONTyped(value?: ListEventEntitiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'pagination': PaginationToJSON(value['pagination']),
    };
}

